<template>
  <div class="resource">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <div class="table-agile-info">
            <div class="searchList">
              <div class="box-content">
                <label class="form-tit">订单编号</label>
                <el-input
                  v-model="searchData.big_order_no"
                  class="jm-input280"/>
              </div>
              <div class="box-content">
                <label class="form-tit">学生姓名</label>
                <el-input
                  v-model="searchData.pub_account"
                  class="jm-input280"/>
              </div>
              <div class="box-content">
                <label class="form-tit">电话</label>
                <el-input
                  v-model="searchData.pub_telphone"
                  class="jm-input280"/>
              </div>
              <div class="box-content">
                <label class="form-tit">到账日期</label>
                <el-date-picker
                  class="jm-input280"
                  v-model="searchData.confirm_time"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
              <div class="box-content">
                <label class="form-tit">支付方式</label>
                <el-select
                  filterable
                  v-model="searchData.payment_method"
                  class="jm-input280"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in tradeDs.payment_method"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">付款时间</label>
                <el-date-picker
                  class="jm-input280"
                  v-model="searchData.paid_time"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间">
                </el-date-picker>
              </div>
              <div class="box-content">
                <label class="form-tit">审核状态</label>
                <el-select
                  filterable
                  v-model="searchData.finance_status"
                  class="jm-input280"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in tradeDs.trade_ex_status"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">缴费类型</label>
                <el-select
                  filterable
                  v-model="searchData.trade_type"
                  class="jm-input280"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in tradeDs.trade_type"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">报账时间</label>
                <el-date-picker
                  class="jm-input280"
                  v-model="searchData.update_time"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="-"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间">
                </el-date-picker>
              </div>
              <div class="box-content box-content-double">
                <label class="form-tit">渠道来源</label>
                <jm-channel v-model="searchData.channels" clearable filterable/>
              </div>
            </div>
            <div class="search-btn">
              <el-button
                class="jm-input-common3"
                type="primary"
                @click="search">搜索</el-button>
              <el-button
                class="jm-input-common3"
                type="default"
                @click="resetFields">重置</el-button>
              <el-button
                v-if="$hasPermission([173, 39, 33, 121, 148])"
                class="jm-input-common3"
                type="success"
                @click="downloadExport">导出</el-button>
            </div>
            <!--列表部分 start -->
            <jm-tableList
              :url="getListurl"
              :search-data="searchData"
            >
              <div name="perfix" slot="perfix" slot-scope="perfix" class="money-end-wrap">
                <a href="javascript:void(0)" @click="currencyUnit = Number(!currencyUnit)">
                  <b v-if="currencyUnit">总额：{{ formatCurrency(perfix.data.totalIncome) }}（{{ formatCurrency(perfix.data.totalIncomeConfirmed) }}）元</b>
                  <b v-else>总额：{{ formatCurrency(perfix.data.totalIncome / 10000) }}（{{ formatCurrency(perfix.data.totalIncomeConfirmed / 10000) }}）万元</b>
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    content="总额标识：当前查询条件的收入总额(已确认收入总额)">
                    <el-button slot="reference" type="primary" icon="el-icon-question" style="padding:0; font-size: 20px"></el-button>
                  </el-popover>
                </a>
              </div>
              <el-table-column
                slot="transaction_id"
                label="交易流水号">
                <template slot-scope="scope">
                  <el-popover
                    placement="top"
                    width="200"
                    trigger="hover">
                    {{ scope.row.transaction_id }}
                    <span slot="reference" class="white-nowrap">{{ scope.row.transaction_id }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                slot="order_no"
                label="拓中流水号">
                <template slot-scope="scope">
                  <el-popover
                    placement="top"
                    width="200"
                    trigger="hover">
                    {{ scope.row.order_no }}
                    <span slot="reference" class="white-nowrap">{{ scope.row.order_no }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                slot="total_amount"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
              >
                <template slot-scope="props">
                  <p>
                    <span>{{ Number(props.row.total_amount) }} 元</span>
                    <span v-if="Number(props.row.real_amount)"> / {{ Number(props.row.real_amount) }}({{ props.row.currency_type_str }})</span>
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                slot="memo"
                label="销售备注">
                <template slot-scope="scope">
                  <el-popover
                    placement="top"
                    width="200"
                    trigger="hover">
                    {{ scope.row.memo }}
                    <span slot="reference" class="white-nowrap">{{ scope.row.memo }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                slot="finance_message"
                label="审核备注">
                <template slot-scope="scope">
                  <el-popover
                    placement="top"
                    width="200"
                    trigger="hover">
                    {{ scope.row.finance_message }}
                    <span slot="reference" class="white-nowrap">{{ scope.row.finance_message }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                slot="lastColumn"
                fixed="right"
                align="center"
                header-align="center"
                width="150"
                label="操作">
                <template slot-scope="scope">
                  <div>
                    <router-link
                      target="_blank"
                      :to="{ name: orderDetail, params: { id: scope.row.pub_userid, orderId: scope.row.big_order_id }}">
                      <el-button size="small" type="primary">查看订单</el-button>
                    </router-link>
                    <el-button
                      v-if="$hasPermission([173]) || ($hasPermission([39]) && scope.row.project_id == 13) || (userInfo.userid === 2243703 && scope.row.project_id == 12)"
                      type="primary"
                      @click="openSpecialDialog(scope.row)"
                      size="small">报账文本
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </jm-tableList>
            <!--列表部分 end-->

            <!--报账文本弹窗 start-->
            <el-dialog
              title="报账内容"
              :visible.sync="specialDialogLock"
              width="600px"
              :show-close="false">
              <el-input
                type="textarea"
                v-model="specialText"
                autosize
                :read-only="true" />
              <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="btnLoading" @click="specialDialogLock = false">确 定</el-button>
              </span>
            </el-dialog>
            <!--报账文本弹窗 end-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';
import { jmChannel } from '@/components/tool';
import { mapGetters } from 'vuex';
import { formatCurrency } from '@/utils/utils';

export default {
  data() {
    return {
      btnLoading: false,
      pageData: {},
      searchData: {
        big_order_no: '',
        pub_account: '',
        pub_telphone: '',
        finance_status: '',
        confirm_time: '',
        paid_time: '',
        payment_method: '',
        update_time: '',
        trade_type: '',
        is_renewal: '',
        is_sync: '',
        extend_data_feetype: '',
      },
      getListurl: '', // 表格数据源
      orderDetail: '', // 订单详情页面
      getDownurl: '', // 下载地址
      exportFileName: '', // 导出文件名
      tradeDs: {},
      specialDialogLock: false,
      specialText: '',
      currencyUnit: 1 // 总额单位
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.meta.a === 'jmpayList') {
      next((vm) => {
        vm.orderDetail = 'jmOrderDetail2022';
        vm.getListurl = '/index/jm.trade2022/list';
        vm.getDownurl = '/index/jm.trade2022/export';
        vm.exportFileName = '芥末留学支付记录.xlsx';
      });
    } else {
      next((vm) => {
        vm.orderDetail = 'qcOrderDetail2022';
        vm.getListurl = '/index/qc.trade2022/list';
        vm.getDownurl = '/index/qc.trade2022/export';
        vm.exportFileName = '前程日本支付记录.xlsx';
      });
    }
    return true;
  },
  methods: {
    // 重置搜索
    resetFields() {
      this.searchData = Object.assign({}, this.searchData, {
        big_order_no: '',
        pub_account: '',
        pub_telphone: '',
        finance_status: '',
        confirm_time: '',
        paid_time: '',
        payment_method: '',
        trade_type: '',
        update_time: '',
        is_renewal: '',
        is_sync: '',
        extend_data_feetype: '',
      });
      this.$store.commit('updateRefresh', true);
    },
    // 打开报账文本弹窗
    openSpecialDialog(row) {
      this.specialDialogLock = true;
      this.specialText = row.special_text;
    },
    search(params = {}) {
      this.searchData = Object.assign({}, this.searchData, params);
      this.$store.commit('updateRefresh', true);
    },
    downloadExport(params = {}) {
      this.btnLoading = true;
      this.searchData = Object.assign({}, this.searchData, params);
      this.$http
        ._post({
          url: this.getDownurl,
          data: {
            searchData: this.searchData,
          }
        })
        .then(({ data }) => {
          this.btnLoading = false;
          this.$http._download({
            filename: data,
            download: this.exportFileName
          });
        })
        .catch(() => {
          this.btnLoading = false;
          this.$message.error('可能数据太多了。。。');
        });
    },
    // 价格格式化
    formatCurrency(price) {
      return formatCurrency(price);
    }
  },
  components: {
    jmChannel,
    'jm-crumbs': crumbs,
    'jm-tableList': tableList
  },
  computed: {
    payType() {
      return this.$route.meta.a.replace('payList', '');
    },
    ...mapGetters(['userInfo']),
  },
  mounted() {
    const getSearchDataUrl = `/index/${this.payType}.trade2022/searchData`;
    this.$http
      ._post({ url: getSearchDataUrl })
      .then((res) => { this.tradeDs = res.data; });
  }
};
</script>
<style scoped>
  .search-btn{
    clear: both;
    text-align: center;
    padding-bottom: 30px;
  }
  .price-show-wrap{
    padding: 20px 0 20px 20px;
    font-size: 16px;
  }
  .price-show-wrap span{
    display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
  }
</style>
